<template>
  <div>
    <el-dialog :visible.sync="dialog" width="1500px" :close-on-click-modal="false" :before-close="reset">
      <span slot="title" class="dialog-title">工程结算</span>
      <div class="dialoginfo">
        <div>
          <el-button v-if="ButtonList.findIndex(res => res.buttonValue == 'TIANJIA') !== -1" size="mini"
            class="bottom_all" style="margin-left: 24px" @click="addSettlement()">
            <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
            添加
          </el-button>
        </div>
        <!-- v-loading="tableLoading" -->
        <div style="margin: 20px 20px">
          <el-table :header-cell-style="{ background: '#f3f6f9', textAlign: 'center' }"
            :cell-style="{ borderRight: 'none', textAlign: 'center' }" border stripe style="width: 100%"
            :height="screenHeight - 450" :data="tableData" tooltip-effect="dark">
            <el-table-column prop="sortNum" label="序号" width="50">
              <template slot-scope="scope">{{ scope.$index + 1 }}</template>
            </el-table-column>
            <el-table-column prop="createTime" label="送审时间" width="135"></el-table-column>
            <el-table-column prop="reviewer" label="送审人" width="135"></el-table-column>
            <el-table-column label="结算数量（方）">
              <el-table-column prop="currentSettlementQuantity" label="本次" width="120"> </el-table-column>
              <el-table-column prop="cumulativeSettlementQuantity" label="累计" width="120"></el-table-column>
            </el-table-column>
            <el-table-column label="结算金额（元）">
              <el-table-column prop="currentSettlementAmount" label="本次" width="120"> </el-table-column>
              <el-table-column prop="cumulativeSettlementAmount" label="累计" width="120"> </el-table-column>
            </el-table-column>
            <el-table-column prop="settlementPeriod" label="结算周期" width="158">
              <template slot-scope="scope">
                <span>{{ scope.row.startTime + "至" + scope.row.endTime }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="settlementNumber" label="编号" width="150"></el-table-column>
            <el-table-column prop="auditNotes" label="审核说明" width="150" show-overflow-tooltip>
              <template slot-scope="scope">
                <span class="ellipsis-text">{{ scope.row.auditNotes }}</span>
              </template>
            </el-table-column>
            <el-table-column label="返回结算数量（方）">
              <el-table-column prop="returnSettlementQuantityCurrent" label="本次" width="120"> </el-table-column>
              <el-table-column prop="returnSettlementQuantityCumulative" label="累计" width="120"> </el-table-column>
            </el-table-column>
            <el-table-column label="返回结算金额（元）">
              <el-table-column prop="returnSettlementAmountCurrent" label="本次" width="120"> </el-table-column>
              <el-table-column prop="returnSettlementAmountCumulative" label="累计" width="120"> </el-table-column>
            </el-table-column>
            <el-table-column prop="url" label="附件" width="130" show-overflow-tooltip>
              <template slot-scope="scope">
                <el-button class="bottom_one" size="mini" @click="lookFile(scope.row)">查看</el-button>
                <!-- <el-link v-if="scope.row.totalSettlementAttachment != '' && scope.row.totalSettlementAttachment != '[]'"
                  :underline="false" class="ellipsis-text" style="color: #3CB371;" @click="downLoad(scope.row)">{{
                    scope.row.totalSettlementAttachment ?
                    JSON.parse(scope.row.totalSettlementAttachment)[0].name : '' }}</el-link>
                <el-link v-else :underline="false" style="color: #a9a9a9;">暂无附件</el-link> -->
                <!-- <el-button class="bottom_one" size="mini" @click="downLoad(scope.row)"> 下载 </el-button> -->
              </template>
            </el-table-column>
            <el-table-column prop="updateTime" label="返回时间" width="135">
              <template slot-scope="scope">
                <span v-if="scope.row.firstSure != 0">{{ scope.row.returnDataTime }}</span>
                <span v-else>*</span>
              </template>
            </el-table-column>
            <el-table-column prop="confirmAuditDescription" label="备注" width="135"></el-table-column>
            <el-table-column prop="firstSure" label="状态" width="135">
              <template slot-scope="scope">
                <span v-if="scope.row.firstSure == 0">未提交</span>
                <span v-else-if="scope.row.firstSure == 1">已提交</span>
                <span v-else-if="scope.row.firstSure == 2">已确认</span>
                <span v-else>*</span>
              </template>
            </el-table-column>
            <el-table-column prop="confirmTime" label="确认时间" width="135"></el-table-column>
            <el-table-column prop="confirmPersion" label="确认人" width="135"></el-table-column>
            <el-table-column label="操作" width="430">
              <template slot-scope="scope">
                <!-- && ButtonList.findIndex(res => res.buttonValue == 'QUEREN' SONGSHENG) !== -1 -->
                <el-button
                  v-if="scope.row.firstSure == 0 && ButtonList.findIndex(res => res.buttonValue == 'SONGSHENG') !== -1"
                  class="bottom_one" style="margin-left: 10px" size="mini"
                  @click="updateDialog(scope.row, scope.$index, false, false)"> 送审数据 </el-button>
                <el-button
                  v-if="scope.row.firstSure == 0 && ButtonList.findIndex(res => res.buttonValue == 'FANHUI') !== -1"
                  class="bottom_one" style="margin-left: 10px" size="mini"
                  @click="updateDialog(scope.row, scope.$index, true, true)"> 返回数据 </el-button>
                <el-button
                  v-if="scope.row.firstSure == 1 && ButtonList.findIndex(res => res.buttonValue == 'QUEREN') !== -1"
                  class="bottom_one" size="mini" @click="updateDialog(scope.row, scope.$index, true, false)"> 确 认
                </el-button>
                <el-button
                  v-if="scope.row.firstSure == 2 && ButtonList.findIndex(res => res.buttonValue == 'XIUGAI') !== -1"
                  class="bottom_one" size="mini" @click="updateDialog(scope.row, scope.$index, true, false)"> 修 改
                </el-button>
                <el-button v-if="scope.row.firstSure == 2" class="bottom_one" size="mini" style="margin-left: 10px"
                  @click="uploadFile(scope.row)"> 上传附件 </el-button>
                <!--未提交 -->
                <!-- scope.row.firstSure == 0 &&  -->
                <el-button v-if="ButtonList.findIndex(res => (res.buttonValue == 'JIESUANSHANCHU')) !== -1"
                  class="bottom_one" style="margin-left: 10px" size="mini" @click="deletesItem(scope.row)"> 删 除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="margin: 20px 20px">
          <el-button v-if="ButtonList.findIndex(res => res.buttonValue == 'TIANJIA') !== -1" size="mini"
            class="bottom_all" style="margin-left: 24px" :disabled="isAdd" @click="addSettlementAll()">
            <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
            添加
          </el-button>
        </div>
        <div style="margin: 20px 20px; display: flex; align-items: center; justify-content: center; height: 100%">
          <div class="titleContainer">总结算</div>
          <div style="flex: 1; height: 100%">
            <!-- 第一部分 -->
            <el-table :header-cell-style="{ background: '#f3f6f9', textAlign: 'center' }"
              :cell-style="{ borderRight: 'none', textAlign: 'center' }" border stripe style="width: 100%; height: 190px"
              :data="tableDataSecond" tooltip-effect="dark">
              <el-table-column prop="createTime" label="送审时间" width="135"></el-table-column>
              <el-table-column prop="reviewer" label="送审人" width="135"></el-table-column>
              <el-table-column label="送审结算数量（方）">
                <el-table-column prop="currentSettlementQuantity" label="本次" width="120"> </el-table-column>
                <el-table-column prop="cumulativeSettlementQuantity" label="累计" width="120"> </el-table-column>
              </el-table-column>
              <el-table-column label="送审结算金额（元）">
                <el-table-column prop="currentSettlementAmount" label="本次" width="120"> </el-table-column>
                <el-table-column prop="cumulativeSettlementAmount" label="累计" width="120"> </el-table-column>
              </el-table-column>
              <el-table-column prop="settlementPeriod" label="结算周期" width="135">
                <template slot-scope="scope">
                  <span>{{ scope.row.startTime + "至" + scope.row.endTime }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="settlementNumber" label="编号" width="auto"></el-table-column>
              <el-table-column prop="auditNotes" label="审核说明" width="auto"></el-table-column>
            </el-table>
            <!-- 第二部分 -->
            <el-table :header-cell-style="{ background: '#f3f6f9', textAlign: 'center' }"
              :cell-style="{ borderRight: 'none', textAlign: 'center' }" border stripe style="width: 100%; height: 175px"
              :data="tableDataSecond" tooltip-effect="dark">
              <el-table-column prop="returnDataTime" label="返回时间" width="200">
                <template slot-scope="scope">
                  <el-date-picker v-model="scope.row.returnDataTime" type="datetime" style="width: 190px;" placeholder="选择日期时间" value-format="yyyy-MM-dd HH:mm:ss" @change="changeReturnTime(scope.row)">
            </el-date-picker>
                </template>
              </el-table-column>
              <el-table-column label="返回结算数量（方）">
                <el-table-column prop="returnSettlementQuantityCurrent" label="本次" width="120"> </el-table-column>
                <el-table-column prop="returnSettlementQuantityCumulative" label="累计" width="120"> </el-table-column>
              </el-table-column>
              <el-table-column label="返回结算金额（元）">
                <el-table-column prop="returnSettlementAmountCurrent" label="本次" width="120"> </el-table-column>
                <el-table-column prop="returnSettlementAmountCumulative" label="累计" width="120"> </el-table-column>
              </el-table-column>
              <el-table-column prop="thirdSure" label="状态" width="135">
                <template slot-scope="scope">
                  <span v-if="scope.row.thirdSure == 0">未提交</span>
                  <span v-else-if="scope.row.thirdSure == 1">已提交</span>
                  <span v-else-if="scope.row.thirdSure == 2">已确认</span>
                  <span v-else>*</span>
                </template>
              </el-table-column>
              <el-table-column prop="confirmTime" label="确认时间" width="135"></el-table-column>
              <el-table-column prop="confirmPersion" label="确认人" width="135"></el-table-column>
              <el-table-column prop="confirmAuditDescription" label="备注" width="auto"></el-table-column>
              <!-- <el-table-column label="操作" width="auto">
                <template slot-scope="scope">
                  <el-button v-if="scope.row.secondSure == 0 && ButtonList.findIndex(res => res.buttonValue == 'XIUGAI') !== -1"  class="bottom_one"  style="margin-left: 10px" size="mini" @click="updateAllDialog(scope.row,false)"> 送审数据 </el-button>
                  <el-button v-if="ButtonList.findIndex(res => res.buttonValue == 'XIUGAI') !== -1"  class="bottom_one"  style="margin-left: 10px" size="mini" @click="updateAllDialog(scope.row,true)"> 返回数据 </el-button>
                  <el-button v-if="scope.row.secondSure == 0" class="bottom_one" size="mini" style="margin-left: 10px" @click="deletesItem(scope.row)"> 删除 </el-button>
                </template>
              </el-table-column> -->
              <!-- <el-button v-if="scope.row.secondSure == 0 && ButtonList.findIndex(res => res.buttonValue == 'QUEREN') !== -1" class="bottom_one" size="mini" @click="confirmItem(scope.row,2)"> 确认 </el-button> -->
            </el-table>
            <!-- 第三部分 -->
            <!-- <el-table :header-cell-style="{ background: '#f3f6f9', textAlign: 'center' }"
              :cell-style="{ borderRight: 'none', textAlign: 'center' }" border stripe style="width: 100%; height: 175px"
              :data="tableDataSecond" tooltip-effect="dark">
              <el-table-column prop="surplusAnalysis" label="盈余分析" width="135"></el-table-column>
              <el-table-column prop="surplusVolume" label="价值表盈余量（方）" width="135"></el-table-column>
              <el-table-column prop="surplusAmount" label="价值表盈余额（元）" width="135"></el-table-column>
              <el-table-column label="金额（元）负为扣减">
                <el-table-column prop="fullAmountOperationalReason" label="经营原因" width="135"> </el-table-column>
                <el-table-column prop="fullAmountQualityReason" label="质量原因" width="135"> </el-table-column>
                <el-table-column prop="fullAmountSupplyMaintenanceReason" label="供保原因" width="135"> </el-table-column>
              </el-table-column>
              <el-table-column prop="totalSettlementAttachment" label="附件" width="130">
                <template slot-scope="scope">
                  <el-button class="bottom_one" size="mini" @click="lookFile(scope.row)">查看</el-button>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="auto">
                <template slot-scope="scope">
                  <el-button
                    v-if="scope.row.thirdSure == 0 && ButtonList.findIndex(res => res.buttonValue == 'SONGSHENG') !== -1"
                    class="bottom_one" style="margin-left: 10px" size="mini"
                    @click="updateAllDialog(scope.row, false, false)"> 送审数据 </el-button>
                  <el-button
                    v-if="scope.row.thirdSure == 0 && ButtonList.findIndex(res => res.buttonValue == 'FANHUI') !== -1"
                    class="bottom_one" style="margin-left: 10px" size="mini"
                    @click="updateAllDialog(scope.row, true, true)"> 返回数据 </el-button>
                  <el-button
                    v-if="scope.row.thirdSure == 1 && ButtonList.findIndex(res => res.buttonValue == 'QUEREN') !== -1"
                    class="bottom_one" size="mini" @click="updateAllDialog(scope.row, true, false)"> 确 认 </el-button>
                  <el-button
                    v-if="scope.row.thirdSure == 2 && ButtonList.findIndex(res => res.buttonValue == 'XIUGAI') !== -1"
                    class="bottom_one" size="mini" @click="updateAllDialog(scope.row, true, false)"> 修 改 </el-button>
                  <el-button v-if="scope.row.thirdSure == 2" class="bottom_one" size="mini" style="margin-left: 10px"
                    @click="uploadFile(scope.row)"> 上传附件 </el-button>
                  <el-button v-if="ButtonList.findIndex(res => (res.buttonValue == 'JIESUANSHANCHU')) !== -1"
                    class="bottom_one" size="mini" style="margin-left: 10px" @click="deletesItem(scope.row)"> 删 除
                  </el-button>
                </template>
              </el-table-column>
            </el-table> -->
            <el-table :header-cell-style="{ background: '#f3f6f9', textAlign: 'center' }"
              :cell-style="{ borderRight: 'none', textAlign: 'center', padding: '0' }" border stripe style="width: 100%; min-height: 175px"
              :data="tableDataSecond" tooltip-effect="dark">
              <el-table-column label="盈余分析">
                <el-table-column prop="surplusVolume" label="价值表盈余量（方）" min-width="160"></el-table-column>
                <el-table-column prop="surplusAmount" label="价值表盈余额（元）" min-width="160"></el-table-column>
              </el-table-column>
              <el-table-column label="争议类型及金额（元）（负为扣减）">
                <el-table-column label="争议类型" min-width="160">
                  <template slot-scope="scope">
                    <template v-if="scope.row.surplusAnalysisList && scope.row.surplusAnalysisList.length > 0">
                      <div v-for="(item, index) in scope.row.surplusAnalysisList" :key="'type'+index" class="inner-list-item">
                        {{ item.disputeType || '-' }}
                      </div>
                    </template>
                    <span v-else>-</span>
                  </template>
                </el-table-column>
                <el-table-column label="金额" min-width="160">
                  <template slot-scope="scope">
                    <template v-if="scope.row.surplusAnalysisList && scope.row.surplusAnalysisList.length > 0">
                      <div v-for="(item, index) in scope.row.surplusAnalysisList" :key="'money'+index" class="inner-list-item">
                        {{ item.disputeMoney !== null && item.disputeMoney !== undefined ? item.disputeMoney : '-' }}
                      </div>
                    </template>
                    <span v-else>-</span>
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column prop="totalSettlementAttachment" label="附件" min-width="130">
                <template slot-scope="scope">
                  <el-button class="bottom_one" size="mini" @click="lookFile(scope.row)">查看</el-button>
                </template>
              </el-table-column>
              <el-table-column label="操作" min-width="350">
                <template slot-scope="scope">
                  <el-button
                    v-if="scope.row.thirdSure == 0 && ButtonList.findIndex(res => res.buttonValue == 'SONGSHENG') !== -1"
                    class="bottom_one" style="margin-left: 10px" size="mini"
                    @click="updateAllDialog(scope.row, false, false)"> 送审数据 </el-button>
                  <el-button
                    v-if="scope.row.thirdSure == 0 && ButtonList.findIndex(res => res.buttonValue == 'FANHUI') !== -1"
                    class="bottom_one" style="margin-left: 10px" size="mini"
                    @click="updateAllDialog(scope.row, true, true)"> 返回数据 </el-button>
                  <el-button
                    v-if="scope.row.thirdSure == 1 && ButtonList.findIndex(res => res.buttonValue == 'QUEREN') !== -1"
                    class="bottom_one" size="mini" @click="updateAllDialog(scope.row, true, false)"> 确 认 </el-button>
                  <el-button
                    v-if="scope.row.thirdSure == 2 && ButtonList.findIndex(res => res.buttonValue == 'XIUGAI') !== -1"
                    class="bottom_one" size="mini" @click="updateAllDialog(scope.row, true, false)"> 修 改 </el-button>
                  <el-button v-if="scope.row.thirdSure == 2" class="bottom_one" size="mini" style="margin-left: 10px"
                    @click="uploadFile(scope.row)"> 上传附件 </el-button>
                  <el-button v-if="ButtonList.findIndex(res => (res.buttonValue == 'JIESUANSHANCHU')) !== -1"
                    class="bottom_one" size="mini" style="margin-left: 10px" @click="deletesItem(scope.row)"> 删 除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="reset">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 上传附件 -->
    <el-dialog v-dialogDrag :visible.sync="uploadFileDig" width="680px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">上传附件</span>
      <div v-loading="loading" element-loading-text="上传中..." element-loading-background="rgba(0, 0, 0, 0.8)"
        class="dialoginfo" style="text-align: center">
        <el-upload class="upload-demo" :on-success="fileSuccess" :before-upload="filebefore" :show-file-list="false" drag
          action="/resource/resources/upload" name="file" :headers="upheader">
          <i slot="trigger" class="el-icon-upload"></i>
          <div slot="trigger" class="el-upload__text">
            将文件拖到此处，或
            <em>点击选取文件</em>
          </div>
          <div slot="tip" class="el-upload__tip" style="color:red">*{{ upload_tip }}</div>
        </el-upload>
        <div style="margin-top: 10px;font-size:18px">
          待保存文件:<span style="color: #00b85c;margin-left: 10px;">{{ filesName }}</span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="uploadFileDig = false">关 闭</el-button>
        <el-button class="bottom_all_two" @click="saveFile">保存</el-button>
      </span>
    </el-dialog>
    <!-- 附件查看 -->
    <el-dialog v-dialogDrag :visible.sync="fileDig" top="15vh" width="560px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">附件</span>
      <div>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
          :height="screenHeight / 2 - 100" style="width: 100%" :data="fileTableData" tooltip-effect="dark">
          <el-table-column label="文件名称" prop="fileName" align="center">
            <template slot-scope="scope">
              <span>
                <el-link type="sucess" :underline="false" @click="lookFileDetail(scope.row)">{{
                  scope.row.fileName }}</el-link>
                <a class="el-link" @click="lookFile2(scope.row)">
                  <i class="el-icon-download" style="padding:0 10px"></i>
                </a>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="closeFile">关 闭</el-button>
      </span>
    </el-dialog>
    <settlementAdd :dialogAdd.sync="addDialog" :params="params" :paramsFromDate="paramsFromDate" :isUpdate="isUpdate"
      :isBack="isBack" :isDisabled="isDisabled" :isShow="isShow" @resetAdd="addDialog = false" @submitAdd="submitAdd">
    </settlementAdd>
    <settlementAddAll :dialogAddAll.sync="addDialogAll" :params="params" :paramsFromDate="paramsFromDate" :isBack="isBack"
      :isDisabled="isDisabled" @resetAddAll="addDialogAll = false" @submitAll="submitAll"></settlementAddAll>
  </div>
</template>
<script>
import mixin from "@/mixins/ICPSmixin.js";
import { querySettlement, saveSettlement, updateUrl,updateReturnTime } from "@/api/internetSales/engineeringControl.js";
import settlementAdd from "./settlementAdd";
import settlementAddAll from "./settlementAddAll";
import { getToken, getUserId } from "@/utils/auth";
import { UPLOAD_TIP } from "@/utils/utils";
export default {
  mixins: [mixin],
  components: {
    settlementAdd,
    settlementAddAll,
  },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    row: {
      type: Object,
      default: new Object(),
    },
  },
  data() {
    return {
      upheader: {
        "access-token": getToken(),
        "user-id": getUserId(),
      },
      addDialog: false,
      addDialogAll: false,
      isAdd: false,
      tableData: [],
      tableDataSecond: [],
      params: {},
      paramsFromDate: {},
      isBack: false,
      isDisabled: false,
      isUpdate: false,
      isShow: false,
      low: {},
      loading: false,
      fileObj: {
        id: "",//主数据id
        totalSettlementAttachment: "",//文件名
      },
      files: [],
      filesName: "",
      fileTableData: [],
      fileDig: false,
      upload_tip: UPLOAD_TIP,
      uploadFileDig: false,
    };
  },
  watch: {
    dialog() {
      if (this.dialog) {
        this.params = this.row;
        this.init(this.params.id);
      }
    },
  },
  created() { },
  methods: {
    changeReturnTime(row){
      console.log(row)
      updateReturnTime({id:row.id,returnDataTime:row.returnDataTime})
    },
    closeFile() {
      this.fileDig = false
    },
    lookFileDetail(row) {
      if (row.path.endsWith('.jpg') || row.path.endsWith('.png') || row.path.endsWith('.jpeg') || row.path.endsWith('.mp4') || row.path.endsWith('.avi') || row.path.endsWith('.wmv') || row.path.endsWith('.mpeg')) {
        let imgUrl = 'https://lvshe.huashijc.com/file/' + row.path;
        window.open(imgUrl, "_blank");
      } else {
        this.$wps(row.path);
      }
    },
    //下载
    lookFile2(row) {
            let imgUrl = 'https://lvshe.huashijc.com/file/' + row.path;
            window.open(imgUrl, "_blank");
        },
    lookFile(row) {
      this.low = JSON.parse(JSON.stringify(row))
      if (this.low.totalSettlementAttachment && this.low.totalSettlementAttachment != "[]") {
        this.fileTableData = JSON.parse(this.low.totalSettlementAttachment);
        this.fileDig = true
      } else {
        this.$message.warning('暂无附件')
      }

    },
    saveFile() {
      this.fileObj.totalSettlementAttachment = JSON.stringify(this.files)
      updateUrl(this.fileObj).then(res => {
        if (res.code == 1001) {
          this.$message.success('保存成功!')
          this.uploadFileDig = false
          this.init(this.params.id);
        }
      })
    },
    filebefore(file) {
      this.loading = true;
      const allowedFormats = ['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/pdf', 'image/jpeg', 'image/jpg', 'image/png', 'application/ofd','video/mp4','video/x-msvideo','video/x-ms-wmv','video/mpeg'];
      const isAllowedFormat = allowedFormats.includes(file.type);
      if (!isAllowedFormat) {
        this.$message.error("数据上传必须是 doc, docx, pdf, jpeg, jpg, png, ofd, mp4, avi,wmv,mpeg 格式!");
        this.loading = false;
      }
      return isAllowedFormat;
    },
    fileSuccess(res) {
      this.loading = false;
      this.fileObj.totalSettlementAttachment = ""
      if (res.code === 1001) {
        const params = {
          name: res.data.fileName,
          fileName: res.data.fileName,
          fileUrl: res.data.fileUrl,
          path: res.data.fileUrl,
          fileType: 1,
          type: 1,
          createTime: new Date().Format("yyyy-MM-dd hh:mm:ss"),
        };
        this.filesName = this.filesName ? this.filesName + ',' + res.data.fileName : res.data.fileName
        this.files.push(params)
      }
    },
    uploadFile(row) {
      this.low = JSON.parse(JSON.stringify(row))
      this.fileObj = this.$options.data().fileObj
      this.fileObj.id = this.low.id
      if (this.low.totalSettlementAttachment && this.low.totalSettlementAttachment != "[]") {
        this.files = JSON.parse(this.low.totalSettlementAttachment);
      } else {
        this.files = [];
      }
      this.filesName = "",
        this.uploadFileDig = true
    },
    setTableData() {
      // 假设tableData是您的数据数组
      console.log(this.tableData)
      if (this.tableData.length > 1) {
        // 表格第一行如果自己有数值------------不参与计算 否则等于当前本次值
        if (this.tableData[0].cumulativeSettlementAmount == "" || this.tableData[0].cumulativeSettlementAmount == null) {
          this.tableData[0].cumulativeSettlementAmount = this.tableData[0].currentSettlementAmount; // 将settlementPrice赋值给settlementPriceAll
          this.tableData[0].cumulativeSettlementQuantity = this.tableData[0].currentSettlementQuantity;
          let sum1 = this.tableData[0].cumulativeSettlementAmount;
          let sum2 = this.tableData[0].cumulativeSettlementQuantity;
          for (let i = 1; i < this.tableData.length; i++) {
            sum1 += this.tableData[i].currentSettlementAmount; // 将当前组的currentSettlementAmount累加到sum中
            sum2 += this.tableData[i].currentSettlementQuantity; // 将当前组的currentSettlementQuantity累加到sum中
            this.tableData[i].cumulativeSettlementAmount = sum1; // 将sum赋值给当前组的settlementPriceAll
            this.tableData[i].cumulativeSettlementQuantity = sum2; // 将sum赋值给当前组的settlementPriceAll
          }
        } else {
          let sum1 = this.tableData[0].cumulativeSettlementAmount;
          let sum2 = this.tableData[0].cumulativeSettlementQuantity;
          for (let i = 1; i < this.tableData.length; i++) {
            sum1 += this.tableData[i].currentSettlementAmount; // 将当前组的currentSettlementAmount累加到sum中
            sum2 += this.tableData[i].currentSettlementQuantity; // 将当前组的currentSettlementQuantity累加到sum中
            this.tableData[i].cumulativeSettlementAmount = sum1; // 将sum赋值给当前组的settlementPriceAll
            this.tableData[i].cumulativeSettlementQuantity = sum2; // 将sum赋值给当前组的settlementPriceAll
          }
        }
        // 返回金额
        if (this.tableData[0].returnSettlementQuantityCumulative == "" || this.tableData[0].returnSettlementQuantityCumulative == null) {
          this.tableData[0].returnSettlementQuantityCumulative = this.tableData[0].returnSettlementQuantityCurrent; // 将settlementPrice赋值给settlementPriceAll
          this.tableData[0].returnSettlementAmountCumulative = this.tableData[0].returnSettlementAmountCurrent;
          let sum3 = this.tableData[0].returnSettlementAmountCumulative;
          let sum4 = this.tableData[0].returnSettlementQuantityCumulative;
          for (let i = 1; i < this.tableData.length; i++) {
            sum3 += this.tableData[i].returnSettlementAmountCurrent; // 将当前组的returnSettlementAmountCurrent累加到sum中
            sum4 += this.tableData[i].returnSettlementQuantityCurrent; // 将当前组的returnSettlementQuantityCurrent累加到sum中
            this.tableData[i].returnSettlementAmountCumulative = sum3; // 将sum赋值给当前组的returnSettlementAmountCumulative
            this.tableData[i].returnSettlementQuantityCumulative = sum4; // 将sum赋值给当前组的returnSettlementQuantityCumulative
          }
        } else {
          let sum3 = this.tableData[0].returnSettlementAmountCumulative;
          let sum4 = this.tableData[0].returnSettlementQuantityCumulative;
          for (let i = 1; i < this.tableData.length; i++) {
            sum3 += this.tableData[i].returnSettlementAmountCurrent; // 将当前组的returnSettlementAmountCurrent累加到sum中
            sum4 += this.tableData[i].returnSettlementQuantityCurrent; // 将当前组的returnSettlementQuantityCurrent累加到sum中
            this.tableData[i].returnSettlementAmountCumulative = sum3; // 将sum赋值给当前组的returnSettlementAmountCumulative
            this.tableData[i].returnSettlementQuantityCumulative = sum4; // 将sum赋值给当前组的returnSettlementQuantityCumulative
          }
        }
      } else if (this.tableData.length === 1) {
        // 如果只有一组数据
        if (this.tableData[0].cumulativeSettlementAmount == "" || this.tableData[0].cumulativeSettlementAmount == null) {
          this.tableData[0].cumulativeSettlementAmount = this.tableData[0].currentSettlementAmount; // 将settlementPrice赋值给settlementPriceAll
          this.tableData[0].cumulativeSettlementQuantity = this.tableData[0].currentSettlementQuantity; // 将settlementNum赋值给settlementNumAll
        }
        if (this.tableData[0].returnSettlementQuantityCumulative == "" || this.tableData[0].returnSettlementQuantityCumulative == null) {
          this.tableData[0].returnSettlementQuantityCumulative = this.tableData[0].returnSettlementQuantityCurrent;
          this.tableData[0].returnSettlementAmountCumulative = this.tableData[0].returnSettlementAmountCurrent;
        }
        else {
          console.log("已有累计金额，无需计算2" + this.tableData[0].cumulativeSettlementAmount)
        }
        console.log(this.tableData)
      }
    },
    addSettlement() {
      // this.params = params
      this.addDialog = true;
      this.isBack = false;
      this.isShow = false;
      this.isDisabled = false;
      this.paramsFromDate = {
        id: "",
        currentSettlementQuantity: "",
        currentSettlementAmount: "",
        settlementNumber: "",
        settlementPeriodLook: [],
        settlementPeriod: "",
        returnSettlementQuantityCurrent: "",
        returnSettlementAmountCurrent: "",
        auditNotes: "",
        internalEventExplain: "",
        engineeringId: "",
        type: 1,
      };
    },
    updateDialog(row, index, type, disable) {
      this.paramsFromDate = row;
      this.addDialog = true;
      if (index == 0) {
        this.isUpdate = false
      } else {
        this.isUpdate = true
      }
      this.isShow = true;
      this.isBack = type;
      this.isDisabled = disable;
    },
    addSettlementAll() {
      this.isBack = false;
      this.paramsFromDate = {
        id: "",
        currentSettlementQuantity: "",
        cumulativeSettlementQuantity: "",
        currentSettlementAmount: "",
        cumulativeSettlementAmount: "",
        settlementNumber: "",
        settlementTime: "",
        returnSettlementQuantityCurrent: "",
        returnSettlementQuantityCumulative: "",
        returnSettlementAmountCurrent: "",
        returnSettlementAmountCumulative: "",
        surplusAnalysis: "",
        surplusVolume: "",
        surplusAmount: "",
        fullAmountOperationalReason: "",
        fullAmountQualityReason: "",
        fullAmountSupplyMaintenanceReason: "",
        type: 2
      }
      this.addDialogAll = true;
    },
    updateAllDialog(row, type, disable) {
      this.paramsFromDate = row;
      this.addDialogAll = true;
      this.isBack = type;
      this.isDisabled = disable;
    },
    submitAdd() {
      // this[key] = false;
    },
    submitAll() { },
    confirmItem(type) {
      this.$confirm("此操作将确认该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "bottom_all_two",
        confirmButtonClass: "bottom_all",
        type: "warning",
      })
        .then(() => {
          var params = {
            id: this.fromDate.id
          }
          if (type == 1) {
            // 0未提交1已提交2已确认
            params.firstSure = 2
          } else {
            params.secondSure = 2
            params.thirdSure = 2
          }
          saveSettlement(params).then(res => {
            if (res.code == 1001) {
              this.$message.success("已确认该数据")
              this.resetAddAll();
            }
          });
        })
        .catch(() => { });
    },
    deletesItem(row) {
      console.log(row)
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "bottom_all_two",
        confirmButtonClass: "bottom_all",
        type: "warning",
      })
        .then(() => {
          saveSettlement({ id: row.id, status: 0 }).then(res => {
            if (res.code == 1001) {
              this.$message.success("删除成功！！")
              this.init(this.params.id);
            }
          });
        })
        .catch(() => { });
    },

    async downLoad(row) {
      var urlList = row.attachment ? JSON.parse(row.attachment) : [];
      for (let file of urlList) {
        await this.downLoadItem(file);
      }
    },
    async downLoadItem(file) {
      window.open("https://lvshe.huashijc.com/file/" + file.fileUrl, file.fileName);
    },
    async downLoadTotal(row) {
      var urlList = row.totalSettlementAttachment ? JSON.parse(row.totalSettlementAttachment) : [];
      for (let file of urlList) {
        await this.downLoadItem(file);
      }
    },
    init(id) {
      // 1过程结算2总结算
      querySettlement({ engineeringId: id, type: 1 }).then(res => {
        if (res.code == 1001) {
          this.tableData = res.data;
          this.setTableData();
        }
      });
      querySettlement({ engineeringId: id, type: 2 }).then(res => {
        if (res.code == 1001) {
          this.tableDataSecond = res.data;
          if (this.tableDataSecond?.length != 0) {
            this.isAdd = true;
          } else {
            this.isAdd = false;
          }
        }
      });
    },
    reset() {
      this.$emit("reset", "settlementDialog");
    },
    submit() {
      // this.$refs.reffromDate.validate(valid => {
      //   if (valid) {
      //     this.fromDate.engineeringId = this.low.id;
      //     saveMaintenance(this.fromDate).then(res => {
      //       if (res.code == 1001) {
      //         this.$message({
      //           message: "保存成功",
      //           type: "success",
      //         });
      //       }
      //       this.$emit("submit", "settlementDialog");
      //     });
      //   } else {
      //     return false;
      //   }
      // });
    },
  },
};
</script>
<style lang="scss" scoped>
.el-input,
.el-select {
  width: 240px;
}

.title {
  font-weight: bold;
  font-size: 18px;
  padding-bottom: 18px;
}

.titleContainer {
  display: flex;
  align-items: center;
  /* 垂直居中 */
  justify-content: center;
  /* 水平居中 */
  height: 540px;
  /* 长方形的高度 */
  width: 50px;
  /* 长方形的宽度 */
  border: 1px solid #ebeef5;
  /* 边框，可视化展示 */
  background: #f3f6f9;
  text-align: center;
  /* 文字水平居中 */
  writing-mode: vertical-rl;
}

.ellipsis-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
/* 争议类型动态列表内部样式 */
.inner-list-item {
  padding: 10px 0;
  border-bottom: 1px solid #ebeef5;
  box-sizing: border-box;
  height: 100%;
}
.inner-list-item:last-child {
  border-bottom: none;
}
</style>
